import type { ResetPasswordWithAccountNumberCredentials } from "@/modules/auth/common/types";
import { setResetFields } from "@/modules/auth/state";
import { resetWithAccountNumberValidationSchema } from "@/modules/auth/validations";
import { useAppDispatch } from "@/shared/hooks";
import { Button } from "@ab.uitools/ui-library/components/Button";
import { FormContainer } from "@ab.uitools/ui-library/components/FormContainer";
import { useTranslation } from "react-i18next";
import type * as Yup from "yup";

import { AccountNumberFormFields } from "./AccountNumberFormFields";

interface Props {
  onSubmit: (
    values: ResetPasswordWithAccountNumberCredentials,
  ) => void;
  isLoading: boolean;
}

const initialValues = {
  accountNumber: "",
};

export const AccountNumberForm = ({ onSubmit, isLoading }: Props) => {
  const { t } = useTranslation();
  const dispatch = useAppDispatch();

  const handleSubmit = (
    val: ResetPasswordWithAccountNumberCredentials,
    isDirty: boolean,
  ) => {
    if (isDirty) {
      dispatch(setResetFields(val));
      onSubmit(val);
    }
  };

  return (
    <div>
      <FormContainer
        className="full-width"
        onSubmit={(data, formState) => handleSubmit(data, formState.isDirty)}
        mode="onBlur"
        reValidateMode="onBlur"
        validationScheme={resetWithAccountNumberValidationSchema({ t }) as Yup.AnyObjectSchema}
        initialValues={initialValues}
        shouldFocusError
      >
        <AccountNumberFormFields/>
        <Button
          isLoading={isLoading}
          className="full-width mt-32"
          buttonActionType="submit"
          buttonText={t("general.confirm")}
          data-testid="reset-account-number-button"
          data-ga-id="reset-account-number-button"
          data-ga-action="Reset action with account number"
        />
      </FormContainer>
    </div>
  );
};
